const initState = {
  mastermind: [],
};

const mastermindReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_MASTER_MIND":
      return { ...state, mastermind: action.payload };
      break;

    default:
      return { ...state };

      break;
  }
};

export default mastermindReducer;
